import { render, staticRenderFns } from "./ModalDosage.vue?vue&type=template&id=6ade4cee"
import script from "./ModalDosage.vue?vue&type=script&lang=js"
export * from "./ModalDosage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports